// Seeded RNG. mulberry32 — fast, decent distribution, deterministic. All
// sim-layer randomness MUST go through this; Math.random is banned in
// src/sim/** by ESLint so smoke runs / replays stay reproducible.

export interface Rng {
  /** Float in [0, 1). */
  next(): number;
  /** Integer in [0, n). Caller ensures n > 0. */
  int(n: number): number;
  /** Float in [a, b). */
  range(a: number, b: number): number;
}

/** Build a mulberry32 RNG from a 32-bit integer seed. */
export function makeRng(seed: number): Rng {
  let a = seed | 0;
  const next = (): number => {
    a = (a + 0x6d2b79f5) | 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    int: (n: number): number => Math.floor(next() * n),
    range: (lo: number, hi: number): number => next() * (hi - lo) + lo,
  };
}

/** Derive a child seed from a parent seed + label, so independent systems can
 *  each get their own deterministic stream without coupling to one another. */
export function deriveSeed(parent: number, label: string): number {
  let h = parent | 0;
  for (let i = 0; i < label.length; i++) {
    h = Math.imul(h ^ label.charCodeAt(i), 0x01000193);
  }
  return h | 0;
}
